// import { createSelector } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Model
import { RootState } from "store";

export const selectResultId = (state:RootState) => state[Reducers.Auth].resultId;
export const selectUserId = (state:RootState) => state[Reducers.Auth].userId;
export const selectAnalyticData = (state:RootState) => state[Reducers.Auth].analyticData;
export const selectIsProfanity = (state:RootState) => state[Reducers.Auth].isProfanity;
